import http from "@/helper/http";
import {useMutation, useQuery} from "@tanstack/react-query";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {DeptPO, RolePO, UserPO} from "@/model/system";
import {WriteContactForm} from "@/pages/Contact/WriteContact";
import {ContactEnum, ContactVO} from "@/service/contact.s";
import {InvoiceEnum} from "@/service/invoice.s";
import {AuditMemberForm} from "@/pages/Member/AuditMember";
import {WriteUserForm} from "@/pages/User/WriteUser";

export enum UserEnum {
    GetRoleUser = "/user/getRoleUser",
    GetUserPage = "/user/getUserPage",
    CreateUser = "/user/createUser",
    UpdateUser = "/user/updateUser",

    GetUser = "/user/getUser",
    AuditUser = "/user/auditUser",
}

export interface RoleUserVO {
    roleAlias?: string
    username: string
    roleId?: string
    deptId?: number
    id: number
}

export interface UserPageBO {}

export interface RoleOfUserVO {
    [key: string]: RoleUserVO[];
}

export interface UserPageVO extends UserPO {
    role: RolePO
    dept: DeptPO
}

export interface UserVO extends UserPO {
    role: RolePO
    dept: DeptPO
}

export const useQueryRoleUser = () =>
    useMutation({mutationFn: () => http.get<BaseVO<RoleOfUserVO>>({url: UserEnum.GetRoleUser})});

export const useQueryUserPage = () => useMutation<BaseVO<PaginationVO<UserPageVO>>, null, UserPageBO>({
    mutationFn: (data: UserPageBO) => http.post<BaseVO<PaginationVO<UserPageVO>>>({
        url: UserEnum.GetUserPage,
        data: data,
    }),
})

export const useAuditUser = () => useMutation({
    mutationFn: (data: AuditMemberForm) => http.post({
        url: UserEnum.AuditUser,
        data
    }),
})

export const useQueryUser = (params: GetByIdBO, enabled = true) => useQuery({
    queryKey: [params.id],
    queryFn: () => http.get<BaseVO<UserVO>>({url: UserEnum.GetUser, params}),
    enabled
});

export const useCreateUser = () => useMutation<BaseVO<null>, null, any>({
    mutationFn: (data: WriteUserForm) =>
        http.put<BaseVO<null>>({url: UserEnum.CreateUser, data})
})

export const useUpdateUser = () => useMutation<BaseVO<null>, null, any>({
    mutationFn: (data: WriteUserForm) =>
        http.post<BaseVO<null>>({url: UserEnum.UpdateUser, data})
})